import { InferType, boolean, object, string } from 'yup';

import Num from '@flipster/utils/num';

export const stakingFormValidator = object({
  amount: string().test({
    test(value, ctx) {
      const { minAmount, maxAmount, availableAmount, currency, isSparkLaunchpool } = ctx.parent;

      if (!!value && !Num(value).isGreaterThanOrEqualTo(minAmount)) {
        const message = isSparkLaunchpool
          ? `${Number(minAmount)} Sparks is the Minimum amount to participate`
          : `${Number(minAmount)} ${currency} is the Minimum staking amount`;
        return ctx.createError({ message });
      }
      if (!!value && !Num(value).isLessThanOrEqualTo(maxAmount)) {
        const message = isSparkLaunchpool
          ? `${Number(maxAmount)} Sparks is the Maximum amount to participate`
          : `${Number(maxAmount)} ${currency} is the Maximum staking amount`;
        return ctx.createError({ message });
      }
      if (!!value && !Num(value).isLessThanOrEqualTo(availableAmount)) {
        const message = isSparkLaunchpool
          ? 'Amount exceeds your available Sparks'
          : 'Please add enough funds to complete this order';
        return ctx.createError({ type: 'insufficient', message });
      }
      return true;
    },
  }),
  isSparkLaunchpool: boolean(),
  minAmount: string().required(),
  maxAmount: string().required(),
  availableAmount: string().required(),
  currency: string().required(),
});

export type StakingFormSchema = InferType<typeof stakingFormValidator>;
